module.exports = "/images/role-manager-icon.svg?ae74b502ddf18d6c14f5ee6798d04726";